import React, {useState, useEffect} from "react";
import styled from 'styled-components';
import {ReactComponent as MailIcon} from './RatesIcon/Pochto.svg';
import {ReactComponent as DeliveryIcon} from './RatesIcon/dilevery.svg';
import {ReactComponent as RegistrationIcon} from './RatesIcon/package.svg';
import {ReactComponent as StorageIcon} from './RatesIcon/Storage.svg';
import {ReactComponent as PhotoIcon} from './RatesIcon/Photo.svg';
import {ReactComponent as Track} from './RatesIcon/Track.svg';
import {ReactComponent as Packaging} from './RatesIcon/Packaging.svg';
import {ReactComponent as Insurance} from './RatesIcon/Insurance.svg';
import {ReactComponent as Ransom} from './RatesIcon/ransom.svg';
import {ReactComponent as Customs} from './RatesIcon/Customs.svg';
import {ReactComponent as Payment} from './RatesIcon/Payment.svg';
import {ReactComponent as Tracking} from './RatesIcon/Tracking.svg';
import {ReactComponent as Limitations} from './RatesIcon/Limitations.svg';
import {ReactComponent as Service} from './RatesIcon/service.svg';
import {ReactComponent as MailboxImage} from './RatesIcon/Mailbox-bro.svg';
import {ReactComponent as DiliveryImage} from './RatesIcon/DiliveryImage.svg';
import WarehouseImage from './RatesIcon/4968469.jpg';
import {ReactComponent as ReceptionImage} from './RatesIcon/Printer-cuate.svg';
import {ReactComponent as PhototsImage} from './RatesIcon/PhototsImage.svg';
import {ReactComponent as RefundImage} from './RatesIcon/RefundImage.svg';
import {ReactComponent as PackaginImage} from './RatesIcon/PackagingImage.svg';
import cardboardBoxImage from './RatesIcon/Card-box.svg';
import plasticBagImage from './RatesIcon/Plastic-paket.svg';
import bubbleWrapImage from './RatesIcon/buble-bag.svg';
import {ReactComponent as Weight} from './RatesIcon/weight.svg';
import {ReactComponent as Volume} from './RatesIcon/Volume.svg';

import {ReactComponent as BoxIcon} from './RatesIcon/box.svg';
import {ReactComponent as RollIcon} from './RatesIcon/roll.svg';
import {ReactComponent as TubeIcon} from './RatesIcon/tube.svg';
import {ReactComponent as Insurances} from './RatesIcon/Insurances.svg';
import {ReactComponent as Preorder} from './RatesIcon/Preorder.svg';
import {ReactComponent as Tomozhka} from './RatesIcon/Tomozhka.svg';
import {ReactComponent as Oplata} from './RatesIcon/Oplata.svg';
import {ReactComponent as Otlezhivania} from './RatesIcon/Otlezhivania.svg';
import {ReactComponent as DopYsluga} from './RatesIcon/DopYsluga.svg';
import {ReactComponent as Ogranicenia} from './RatesIcon/Ogranicenia.svg';
import AnimationRevealPage from "../../components/helpers/AnimationRevealPage";
import Footer from "../../components/footers/MainFooterWithLinks";
import Header from "../../components/headers/MainHeader";
import {useMemo} from "react";
import DesignIllustration from "./../../images/Без имени-1.png";
import tw from "twin.macro";
import {useTranslation} from "react-i18next";

const Layout = styled.div`
    display: flex;
    flex-direction: column;
    background: #fff;
    border-radius: 15px;
    box-shadow: 10px 10px 10px rgba(45, 45, 45, 0.10);
    overflow: hidden;
    max-width: 1400px;
    margin: 100px auto; // Добавлен отступ сверху
    height: auto;
    @media (min-width: 768px) {
        flex-direction: row;
    }
`;


const SidebarContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: #ffffff;
    border-right: 1px solid #F5F5F5;
    @media (min-width: 768px) {
        width: 400px;
    }
`;

const TabButton = styled.button`
    ${tw`text-sm sm:text-sm font-semibold text-center`}
    display: flex;

    align-items: center;
    background: ${({active}) => (active ? '#DDF2E6' : 'transparent')};
    color: #243e63; /* Установлен синий цвет */
    border: none;
    padding: 10px 22px;
    line-height: 18px;
    cursor: pointer;
    text-align: left;

    &:hover {
        background-color: #DDF2E6;
    }

    svg {
        margin-right: 20px;
        width: 30px;
        height: 30px;
    }
`;

const Title = styled.h1`
    ${tw`font-bold text-2xl md:text-2xl lg:text-2xl  leading-tight`} /* Центрируем текст на маленьких экранах */



`;

const SectionContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: start;
    padding: 20px;
    gap: 20px;
`;

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex: 1;
    min-width: 300px;
    height: 250px;
`;

const Icon = styled.img`
    width: 50px;
    height: 50px;
    margin-bottom: 15px;
`;

const Text = styled.p`
    font-size: 16px;
    color: #2D2D2D;
    text-align: center;
    line-height: 1.4;
    margin: 0;
    flex-grow: 1;
    overflow: hidden;
`;

const ContentContainer = styled.div`
    flex: 1;
    padding: 20px;
    transition: opacity 0.5s ease;
    opacity: ${({isActive}) => (isActive ? 1 : 0)};
`;

const IconContainer = styled.span``;

const StyledParagraph = styled.p`
    ${tw`text-lg `};
    padding: 0;
    margin-bottom: 30px;

    line-height: 30px;
    color: #2D2D2D;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    outline: none;
    cursor: default;
    text-align: left;
`;
const NoSpacingParagraph = styled(StyledParagraph)`
    margin-bottom: 10px;
`;

const StyledDescription = styled.p`
    ${tw`text-lg `};
    padding: 0;
    margin-bottom: 30px;
    line-height: 30px;
    color: #2D2D2D;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    box-sizing: border-box;
    outline: none;
    cursor: default;
    text-align: center;
`;

const Highlight = styled.span`
    color: #0ABD19; // Green color for emphasis
`;

const PackagingOption = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px;
`;

const PackagingImage = styled.img`
    width: 100px;
    height: auto;
    margin-bottom: 30px;
`;

const PackagingDescription = styled.span`
    text-align: center;
    font-size: 14px;
    color: #666;
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    padding: 20px;
`;

const Card = styled.div`
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); // Add shadow
    width: 30%; // Set width of each card
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

const CardTitle = styled.h2`
    color: #333;
    font-size: 18px;
    margin-bottom: 10px;
`;

const CardFormula = styled.div`
    font-size: 16px;
    color: #666;
    text-align: center;
`;

const Fraction = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-top: 4px;
`;

const FormulaNote = styled.div`
    font-size: 14px;
    margin-top: 8px;
    text-align: center;
    color: #666;
`;
const FormulaContainer = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    margin-left: 6px;
    vertical-align: middle;
`;

const Numerator = styled.span`
    border-bottom: 1px solid #ccc;
    padding-bottom: 3px;
    font-size: 14px;
`;

const Denominator = styled.span`
    padding-top: 3px;
    font-size: 14px;
`;


const CardIcon = styled.div`
    width: 60px; // Set width of the icon container
    height: 60px; // Set height of the icon container
    margin-bottom: 15px; // Space between the icon and the title
    display: flex; // Use flexbox to center the icon
    align-items: center; // Center the icon vertically
    justify-content: center; // Center the icon horizontally

    svg {
        width: 100%; // Ensure the SVG fills the container
        height: auto; // Maintain the aspect ratio of the icon
    }
`;

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

const TableRow = styled.tr``;

const TableHeader = styled.th`
    padding: 8px;
    border: 1px solid #ccc;
    background-color: #f8f9fa;
    text-align: center;
`;

const TableCell = styled.td`
    padding: 8px;
    border: 1px solid #ccc;
    text-align: center;
`;

const CardContainer1 = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: nowrap; // Disable wrapping to new lines
    overflow-x: auto; // Add horizontal scroll if cards don't fit
    padding-bottom: 20px; // Add padding at the bottom to not overlap the horizontal scroll
`;
export default function App() {

    const {t, i18n} = useTranslation();

    const tabs = useMemo(() => [
        {
            name: t("rates.addressTitle"),
            content: (
                <div>
                    <Title>{t("rates.addressTitle")}</Title>
                    <StyledParagraph>{t("rates.addressDescription")}</StyledParagraph>
                    <StyledParagraph>
                        {t("rates.addressPrice")} <Highlight>{t("rates.free")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: MailIcon
        },


        {
            name: t("rates.deliveryTitle"),
            content: (
                <div>
                    <Title>{t("rates.deliveryTitle")}</Title>

                    <StyledParagraph>
                        {t("rates.deliveryDescription1")}
                    </StyledParagraph>

                    <StyledParagraph>
                        <Highlight>{t("rates.deliveryPriceHighlight")}</Highlight>
                        {t("rates.deliveryDescription2")}
                    </StyledParagraph>
                </div>
            ),
            Icon: DeliveryIcon, // если есть иконка
        },

        {
            name: t("rates.registrationTitle"),
            content: (
                <div>
                    <Title>{t("rates.registrationTitle")}</Title>

                    <NoSpacingParagraph>{t("rates.registrationDescription1")}</NoSpacingParagraph>
                    <NoSpacingParagraph>{t("rates.registrationDescription2")}</NoSpacingParagraph>
                    <NoSpacingParagraph>{t("rates.registrationDescription3")}</NoSpacingParagraph>
                    <NoSpacingParagraph>{t("rates.registrationDescription4")}</NoSpacingParagraph>

                    <StyledParagraph>
                        {t("rates.registrationPrice")} <Highlight>– {t("rates.free")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: RegistrationIcon
        },
        {
            name: t("rates.photoTitle"),
            content: (
                <div>
                    <Title>{t("rates.photoTitle")}</Title>

                    <StyledParagraph>{t("rates.photoDescription")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.photoPrice")} <Highlight>{t("rates.photoHighlight")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: PhotoIcon
        }
        ,
        {
            name: t("rates.returnTitle"),
            content: (
                <div>
                    <Title>{t("rates.returnTitle")}</Title>

                    <StyledParagraph>{t("rates.returnDescription")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.returnPrice")} <Highlight>{t("rates.returnHighlight")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: Track
        }
        ,
        {
            name: t("rates.packagingTitle"),
            content: (
                <div>
                    <Title>{t("rates.packagingTitle")}</Title>

                    <StyledParagraph>{t("rates.packagingDescription")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.packagingPrice")} <Highlight>{t("rates.free")}</Highlight>
                    </StyledParagraph>

                    <Title>{t("rates.packagingSubTitle")}</Title>
                    <StyledDescription>{t("rates.packagingSubDescription")}</StyledDescription>

                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <PackagingOption>
                            <PackagingImage src={cardboardBoxImage} alt={t("rates.cardboard")}/>
                            <PackagingDescription>{t("rates.cardboard")}</PackagingDescription>
                        </PackagingOption>
                        <PackagingOption>
                            <PackagingImage src={plasticBagImage} alt={t("rates.plastic")}/>
                            <PackagingDescription>{t("rates.plastic")}</PackagingDescription>
                        </PackagingOption>
                        <PackagingOption>
                            <PackagingImage src={bubbleWrapImage} alt={t("rates.bubble")}/>
                            <PackagingDescription>{t("rates.bubble")}</PackagingDescription>
                        </PackagingOption>
                    </div>

                    <SectionContainer>
                        <InfoContainer>
                            <Icon as={Weight}/>
                            <Title>{t("rates.weightTitle")}</Title>
                            <Text>{t("rates.weightDescription")}</Text>
                        </InfoContainer>

                        <InfoContainer>
                            <Icon as={Volume}/>
                            <Title>{t("rates.volumeWeightTitle")}</Title>
                            <Text>
                                {t("rates.volumeWeightDescription")}
                                <FormulaContainer>
                                    <Numerator>{t("rates.volumeFormulaNumerator")}</Numerator>
                                    <Denominator>{t("rates.volumeFormulaDenominator")}</Denominator>
                                </FormulaContainer>
                            </Text>
                        </InfoContainer>
                    </SectionContainer>

                    <CardContainer1>
                        <Card>
                            <CardIcon><BoxIcon/></CardIcon>
                            <CardTitle>{t("rates.boxTitle")}</CardTitle>
                            <CardFormula>
                                <div>{t("rates.volumeWeightEq")}</div>
                                <Fraction>
                                    <Numerator>{t("rates.volumeFormulaNumerator")}</Numerator>
                                    <Denominator>{t("rates.volumeFormulaDenominator")}</Denominator>
                                </Fraction>
                            </CardFormula>
                        </Card>

                        <Card>
                            <CardIcon><RollIcon/></CardIcon>
                            <CardTitle>{t("rates.rollTitle")}</CardTitle>
                            <CardFormula>
                                <div>{t("rates.volumeWeightEq")}</div>
                                <Fraction>
                                    <Numerator>{t("rates.rollFormulaNumerator")}</Numerator>
                                    <Denominator>{t("rates.volumeFormulaDenominator")}</Denominator>
                                </Fraction>
                                <FormulaNote>{t("rates.rollNote")}</FormulaNote>
                            </CardFormula>
                        </Card>

                        <Card>
                            <CardIcon><TubeIcon/></CardIcon>
                            <CardTitle>{t("rates.tubeTitle")}</CardTitle>
                            <CardFormula>
                                <div>{t("rates.volumeWeightEq")}</div>
                                <Fraction>
                                    <Numerator>{t("rates.tubeFormulaNumerator")}</Numerator>
                                    <Denominator>{t("rates.volumeFormulaDenominator")}</Denominator>
                                </Fraction>
                                <FormulaNote>{t("rates.tubeNote")}</FormulaNote>
                            </CardFormula>
                        </Card>
                    </CardContainer1>
                </div>
            ),
            Icon: Packaging
        },

        {
            name: t("rates.insuranceTitle"),
            content: (
                <div>
                    <Title>{t("rates.insuranceTitle")}</Title>

                    <StyledParagraph>{t("rates.insuranceDescription")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.serviceCost")} <Highlight>{t("rates.insurancePrice")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: Insurance
        }
        ,
        {
            name: t("rates.ransomTitle"),
            content: (
                <div>
                    <Title>{t("rates.ransomTitle")}</Title>

                    <StyledParagraph>{t("rates.ransomDescription1")}</StyledParagraph>

                    <StyledParagraph>{t("rates.ransomDescription2")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.serviceCost")} <Highlight>{t("rates.ransomPrice")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: Ransom
        },
        {
            name: t("rates.customsTitle"),
            content: (
                <div>
                    <Title>{t("rates.customsTitle")}</Title>

                    <StyledParagraph>{t("rates.customsDescription")}</StyledParagraph>

                    <StyledParagraph>
                        {t("rates.serviceCost")} <Highlight>{t("rates.customsPrice")}</Highlight>
                    </StyledParagraph>
                </div>
            ),
            Icon: Customs
        }
        ,
        {
            name: t("rates.paymentTitle"),
            content: (
                <div>
                    <Title>{t("rates.paymentTitle")}</Title>

                    <StyledParagraph>
                        {t("rates.paymentDescription")} <Highlight>{t("rates.paymentCards")}</Highlight>
                    </StyledParagraph>

                    <Title>{t("rates.refundTitle")}</Title>

                    <StyledParagraph>{t("rates.refundDescription")}</StyledParagraph>
                </div>
            ),
            Icon: Payment
        }
        ,
        {
            name: t("rates.trackingTitle"),
            content: (
                <div>
                    <Title>{t("rates.trackingTitle")}</Title>

                    <StyledParagraph>{t("rates.trackingDescription")}</StyledParagraph>
                </div>
            ),
            Icon: Tracking
        }
        ,
        {
            name: t("rates.limitationsTitle"),
            content: (
                <div>
                    <Title>{t("rates.limitationsTitle")}</Title>

                    <StyledParagraph>{t("rates.limitationsDescription")}</StyledParagraph>
                </div>
            ),
            Icon: Limitations
        }
        ,
        {
            name: t("rates.additionalTitle"),
            content: (
                <div>
                    <Title>{t("rates.additionalTitle")}</Title>

                    <StyledParagraph>{t("rates.additionalDescription1")}</StyledParagraph>

                    <StyledParagraph>{t("rates.additionalDescription2")}</StyledParagraph>
                </div>
            ),
            Icon: Service
        }
        ,

    ], [i18n.language]);
    const [activeTab, setActiveTab] = useState(0);
    const [activeContent, setActiveContent] = useState(tabs[0].content);
    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        setIsActive(false);
        setTimeout(() => {
            setActiveContent(tabs[activeTab].content);
            setIsActive(true);
        }, 500);
    }, [activeTab, i18n.language]); // <-- добавлено i18n.language


    return (
        <AnimationRevealPage>
            <Header
                heading={t("rates.headerTitle")}
                paragraph={t("rates.headerDescription")}
                imageSrc={DesignIllustration}
                roundedHeaderButton={false}
            />

            <Layout>
                <SidebarContainer>
                    {tabs.map((tab, index) => (
                        <TabButton
                            key={index}
                            active={index === activeTab}
                            onClick={() => setActiveTab(index)}
                        >
                            <IconContainer>{<tab.Icon active={index === activeTab}/>}</IconContainer>
                            {tab.name}
                        </TabButton>
                    ))}
                </SidebarContainer>
                <ContentContainer isActive={isActive}>
                    {activeContent}
                </ContentContainer>
            </Layout>
            <Footer/>
        </AnimationRevealPage>
    );
}
